import script from "./CaskChatroomBody.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskChatroomBody.vue?vue&type=script&setup=true&lang=js"

import "./CaskChatroomBody.vue?vue&type=style&index=0&id=19a53e68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a53e68"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QImg,QBadge,QIcon,QSpinnerIos,QSpinnerPie});
